import { Badge } from '@/components/shadcn/badge'
import { SortingHeaderButton } from '@/components/ui/DataTable/SortingHeaderButton'
import { RestSchemas } from '@/contexts/QueryProvider'
import { deriveRoleNamesFromRoleNumber } from '@/util/roles'
import { ColumnDef } from '@tanstack/react-table'
import clsx from 'clsx'
import { RowActionsMenu } from './RowActionsMenu'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { IconAvatarOutline } from '@icons/IconAvatarOutline'

type MessagesSubscriptionsOrganisationUser = RestSchemas['Messages.Subscriptions.OrganisationUser']

export const columns: ColumnDef<MessagesSubscriptionsOrganisationUser>[] = [
  {
    id: 'name',
    accessorFn: (row) => clsx(row.givenName, row.familyName, row.email),
    header: ({ column }) => <SortingHeaderButton column={column}>Name</SortingHeaderButton>,
    cell: ({ row }) => (
      <div className="group flex items-start gap-x-4">
        <TooltipButton tooltip={row.original.isFrozen ? 'Frozen' : row.original.active ? 'Active' : 'Inactive'}>
          <div
            className={clsx(
              'flex size-10 shrink-0 items-center justify-center rounded-full',
              row.original.isFrozen ? 'bg-accent/10' : row.original.active ? 'bg-primary/10' : 'bg-offwhite'
            )}
          >
            <IconAvatarOutline
              className={clsx(
                'size-5',
                row.original.isFrozen ? 'text-accent' : row.original.active ? 'text-primary' : 'text-muted-foreground'
              )}
            />
          </div>
        </TooltipButton>
        <div className="flex flex-col gap-y-1">
          <span className="text-base group-hover:underline">
            {clsx(row.original.givenName, row.original.familyName)}
          </span>
          <span className="text-xs font-light leading-[1.1] text-muted-foreground">{row.original.email}</span>
        </div>
      </div>
    ),
    sortingFn: (rowA, rowB) => rowA.original.givenName.localeCompare(rowB.original.familyName),
  },
  {
    id: 'roles',
    header: 'Roles',
    cell: ({ row }) => (
      <div className="flex flex-wrap gap-1">
        {deriveRoleNamesFromRoleNumber(row.original.roles).map((role) => (
          <Badge variant="secondary" key={`${row.original.id}-${role}`}>
            {role}
          </Badge>
        ))}
      </div>
    ),
  },
  {
    id: 'actions',
    // header: 'Actions',
    cell: ({ row }) => (
      <div className="flex justify-end pr-5">
        <RowActionsMenu user={row.original} />
      </div>
    ),
  },
]
